export const ZIPPEDI_CLIENT_ID = -1;
export const JUMBO_CLIENT_ID = 0;

export const FAMILY_ID_INTERN = 12;
export const FAMILY_ID_SUPER_USER = 9;

export const DATE_HOUR_FORMAT = 'dd/MM/yyyy HH:mm'

// Tasks list
export const ADJUSTMENT_TASK = "adjustment"
export const DYNAMIC_NAVIGATION_MAP_TASK = "dynamic_navigation_map"
export const INACTIVE_PRODUCT_TASK = "inactive_product"
export const INACTIVE_PROMOTION_TASK = "inactive_promotion"
export const MISPLACED_PRODUCT_TASK = "misplaced_product"
export const MISSING_AT_LOCATION_TASK = "missing_at_location"
export const MISSING_IN_STORE_TASK = "missing_in_store"
export const MISSING_LANDMARK_TASK = "missing_landmark"
export const MISSING_PROMOTION_TASK = "missing_promotion"
export const OSA_TASK = "OSA"
export const PARTIAL_STOCKOUT_TASK = "partial_stockout"
export const PRICE_DIFFERENCE_TASK = "price_difference"
export const STOCKOUT_TASK = "stockout"
export const UNEXPECTED_LOCATION_TASK = "unexpected_location"
export const UNIMPLEMENTED_TASK = "unimplemented"
export const ROBOT_NAVIGATION_TASK = "robot_navigation"
// TODO: this tasks are in the process of deprecation
export const PROMOTIONS_TASK = "promotions"

// Task types with no date-range download.
export const DATE_RANGE_DOWNLOAD_UNSUPPORTED_TASKS = [
  ROBOT_NAVIGATION_TASK,
  DYNAMIC_NAVIGATION_MAP_TASK,
]

export const NAVIGATION_PDF_MAX_AGE_DAYS = 14
